<bd-ai-assistant-v2
  [messages]="chat().messages"
  [status]="chat().status"
  [suggestions]="promptSuggestions()"
  [visualSuggestions]="insightSuggestions()"
  [refreshingVisualSuggestions]="areInsightSuggestionsLoading()"
  [showSuggestionsPanel]="showSuggestionsPanel()"
  [insightData]="insightData()"
  [feedbackConfig]="feedbackConfig()"
  [fileUploadEnabled]="fileUploadEnabled()"
  [startNewChatEnabled]="deliverablePersistenceEnabled()"
  [chatHistoryEnabled]="deliverablePersistenceEnabled()"
  [assistantPanelVisible]="assistantPanelVisible()"
  [(chatHistoryPanelOpen)]="chatHistoryPanelOpen"
  [chatSessions]="chatSessions()"
  [chatSessionsStatus]="chatSessionsStatus()"
  [chatSessionsHasMore]="chatSessionsHasMore()"
  [chatSessionsSearchTerm]="chatSessionsSearchTerm()"
  [chatSessionsSort]="chatSessionsSort()"
  [chatSessionsScope]="chatSessionsScope()"
  [hasFrameContext]="hasFrameContext()"
  [activeChatSessionId]="activeChatSessionId()"
  [chatSessionLoadingId]="chatSessionLoadingId()"
  [chatSessionDeletingIds]="chatSessionDeletingIds()"
  [chatSessionRenamingId]="chatSessionRenamingId()"
  [isUploadingAttachments]="isUploadingAttachments()"
  [localAttachmentPreviews]="localAttachmentPreviews()"
  [thinkingNote]="thinkingNote()"
  [plan]="plan()"
  [continuationPending]="continuationPending()"
  [awaitingInstructions]="awaitingInstructions()"
  (messageSent)="onMessageSent($event)"
  (navigationRequested)="onNavigationRequested($event)"
  (attachmentsRejected)="onAttachmentsRejected($event)"
  (downloadAttachment)="onDownloadAttachment($event)"
  (requestAttachmentPreview)="onRequestAttachmentPreview($event)"
  (stopRequested)="onStopRequested()"
  (clearRequested)="onClearRequested()"
  (chatHistoryOpened)="onChatHistoryOpened()"
  (chatSessionSelected)="onChatSessionSelected($event)"
  (chatSessionsDeleteRequested)="onChatSessionsDeleteRequested($event)"
  (chatSessionsRenameRequested)="onChatSessionsRenameRequested($event)"
  (chatSessionsLoadMoreRequested)="onChatSessionsLoadMoreRequested()"
  (chatSessionsSearchRequested)="onChatSessionsSearchRequested($event)"
  (chatSessionsSortChanged)="onChatSessionsSortChanged($event)"
  (chatSessionsScopeChanged)="onChatSessionsScopeChanged($event)"
  (suggestionClicked)="onSuggestionClicked($event)"
  (thumbsUp)="onThumbsUp($event)"
  (thumbsDown)="onThumbsDown($event)"
  (feedbackPrompted)="onFeedbackPrompted($event)"
  (feedbackSkipped)="onFeedbackSkipped($event)"
  (selectedVisualSuggestion)="onSelectedVisualSuggestion($event)"
  (insightChartClicked)="onInsightChartClicked($event)"
  (optionSelected)="onOptionSelected($event)"
  [optionSendResult]="optionSendResult()"
  (connectMcpClicked)="onConnectMcpClicked($event)"
/>
@let layoutContext = layoutContext$ | async;
@if (layoutContext === 'overlay') {
  <div class="bd-overlay-toolbar">
    <bd-frame-overlay-toolbar
      class="pointer-events-auto bd-toolbar-float"
      aria-label="Overlay toolbar"
      [canUndoUserPrompt]="false"
      [canRedoUserPrompt]="false"
      [canSaveToWorkspace]="canSaveToWorkspace()"
      (onCloseSuggestion)="onCloseOverlay()"
      (onSaveToWorkspace)="onSaveToWorkspace()"
    ></bd-frame-overlay-toolbar>
  </div>
}
<ng-container *transloco="let tWS; scope: 'featureWorkspaces'">
  <bd-content-open-container
    [visible]="(workspacePickerDialogVisible$ | async) ?? false"
    (visibleChange)="workspacePickerDialogVisible$.next($event)"
    (selectionConfirm)="onWorkspacePickerSelectionConfirm($event)"
    [showOnlyWorkspaceStep]="true"
    [dialogTitle]="tWS('featureWorkspaces.workspace.addToWorkspaceTitle')"
  />
</ng-container>
@if (!deliverablePersistenceEnabled()) {
  @if (clearChatDialogProperties$ | async; as clearChatDialogProperties) {
    <bd-dialog
      [visible]="(clearChatDialogVisible$ | async) ?? false"
      (visibleChange)="clearChatDialogVisible$.next($event)"
      [dialogProperties]="clearChatDialogProperties"
      (confirm)="onClearChatConfirm()"
      data-id="assistant-clear-chat-dialog"
    >
      <div *transloco="let t; scope: 'featureAiAssistant'">
        <span class="bd-body-large bd-ellipsis-text">{{
          t('featureAiAssistant.dialog.clearChat.description')
        }}</span>
      </div>
    </bd-dialog>
  }
}
